import React, { useEffect, useState } from 'react';

const KEY = 'healing.excludeHomeopathy';

/** Read the persisted global Homeopathy-omission setting. */
export function getExcludeHomeopathy() {
  try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
}

/**
 * Global cross-module toggle: when ON, tabular views strip data tied to the Homeopathy
 * department. Persisted in localStorage so the preference follows the user across modules;
 * a storage event keeps multiple mounted toggles in sync.
 */
export function useExcludeHomeopathy() {
  const [on, setOn] = useState(getExcludeHomeopathy);
  useEffect(() => {
    const sync = () => setOn(getExcludeHomeopathy());
    window.addEventListener('storage', sync);
    window.addEventListener('healing:homeo-toggle', sync);
    return () => { window.removeEventListener('storage', sync); window.removeEventListener('healing:homeo-toggle', sync); };
  }, []);
  const toggle = (next) => {
    try { localStorage.setItem(KEY, next ? '1' : '0'); } catch { /* */ }
    setOn(next);
    window.dispatchEvent(new Event('healing:homeo-toggle'));
  };
  return [on, toggle];
}

/** True when a procedure/treatment label belongs to the Homeopathy department. */
export function isHomeo(name) {
  return typeof name === 'string' && name.toLowerCase().includes('homeo');
}

export default function HomeoToggle() {
  const [on, toggle] = useExcludeHomeopathy();
  // Brief "Applying filter…" affordance: flipping the toggle re-runs every homeo-aware query
  // (leads, billing, all report tabs). Surface that work so a slow refetch doesn't look frozen.
  const [applying, setApplying] = useState(false);
  useEffect(() => {
    if (!applying) return undefined;
    const t = setTimeout(() => setApplying(false), 900);
    return () => clearTimeout(t);
  }, [applying]);
  const onChange = (e) => { setApplying(true); toggle(e.target.checked); };
  return (
    <label
      style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: '0.82rem', color: 'var(--text-secondary)', cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
      title="Global filter: exclude all Homeopathy-department data from this view"
    >
      <input type="checkbox" checked={on} onChange={onChange} />
      <span>Exclude Homeopathy</span>
      {applying && (
        <span style={{ fontSize: '0.72rem', color: 'var(--accent, #6366f1)', fontStyle: 'italic' }}>
          Applying filter…
        </span>
      )}
    </label>
  );
}
